export default function SpacingMedium({ sectionId }) {
return (
<div
id={sectionId}
style={{
height: "var(--padding-lg)",
width: "100%"
}}
/>
);
}